const ServerAPI = process.env.SERVER_API;
//import { UIContext } from 'contexts/UIContext';
function getServer() {
    let url = null;
    switch (window.location.host) {
        case '127.0.0.1:3000':
            url = 'http://127.0.0.1:3001';
            break;
        case '172.30.1.26:3000':
            url = 'http://172.30.1.26:3001';
            break;
        case '192.168.84.97:3000':
            url = 'http://192.168.84.97:3001';
            break;
        case 'localhost:3000':
            url = 'http://172.30.1.26:3001';
            break;
        default:
            url = ServerAPI;
            break;
    }
    return url;
}
function getFileServer() {
    let url = null;
    switch (window.location.host) {
        case 'localhost:3000':
            url = 'http://localhost:4000';
            break;
        case '127.0.0.1:3000':
            url = 'http://localhost:4000';
            break;
        default:
            url = 'https://file.visecare.com';
            break;
    }
    return url;
}
export async function requestAPI(method, path, data) {
    try {
        const apiServer = getServer();
        const fileServer = getFileServer();
        //const apiServer = (window.location.host === '127.0.0.1:3000')? 'http://127.0.0.1:3001' : ServerAPI;
        let response = null;
        let returnData = null;
        console.log(`api request start ${method} ${path}`);
        switch (method) {
            case 'GET':
                response = await fetch(`${apiServer}/${path}`, {
                    credentials: 'include',
                });
                console.log('api 0-1');
                break;
            case 'POST':
                response = await fetch(`${apiServer}/${path}`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        // 기타 필요한 헤더들 추가
                    },
                    credentials: 'include',
                    body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
                });
                break;
            case 'PUT':
                response = await fetch(`${apiServer}/${path}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                        // 기타 필요한 헤더들 추가
                    },
                    credentials: 'include',
                    body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
                });
                break;
            case 'DELETE':
                response = await fetch(`${apiServer}/${path}`, {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        // 기타 필요한 헤더들 추가
                    },
                    credentials: 'include',
                    body: JSON.stringify(data) // 요청 데이터(JSON 형식) 설정
                });
                break;
            case 'FILE':
                //response = await fetch(`${ServerFILE}/${path}`, {
                response = await fetch(`${fileServer}/${path}`, {
                    method: 'POST',
                    headers: {
                    // 	//"accept-charset": "UTF-8"
                    // 	//'Content-Type': 'application/json',
                    // 	'Content-Type': 'charset=utf-8',
                    // 	// 기타 필요한 헤더들 추가
                    },
                    //credentials: 'include',
                    body: data
                });
                break;
        }
        console.log('api end');
        returnData = await response.json();
        console.log('api response');
        return returnData;
    }
    catch (err) {
        console.log('Catch Catch Catch');
    }
}
